import type { Mask } from "@/core/types"
import { hashObject } from "@/utils/hash"

function getMaskPixelInput(mask: Mask) {
	const common = {
		type: mask.type,
		inverted: mask.inverted,
		blendMode: mask.blendMode,
	}

	switch (mask.type) {
		case "radial":
			return {
				...common,
				centerX: mask.centerX,
				centerY: mask.centerY,
				radiusX: mask.radiusX,
				radiusY: mask.radiusY,
				angle: mask.angle,
				feather: mask.feather,
			}
		case "gradient":
			return {
				...common,
				startX: mask.startX,
				startY: mask.startY,
				endX: mask.endX,
				endY: mask.endY,
			}
		case "brush":
			return {
				...common,
				strokes: mask.strokes.map((stroke) => ({
					points: stroke.points,
					size: stroke.size,
					flow: stroke.flow,
					feather: stroke.feather,
					density: stroke.density,
					isErasing: stroke.isErasing,
				})),
			}
		case "people": {
			const personIndexes = mask.personIndexes?.length
				? mask.personIndexes
				: mask.personIndex !== undefined
					? [mask.personIndex]
					: undefined
			return {
				...common,
				personIndexes,
				peoplePart: mask.peoplePart ?? "entire",
			}
		}
		case "subject":
		case "background":
		case "sky":
			return common
	}
}

export function getMaskGroupDigest(masks: Mask[]) {
	// Hash only fields that change rendered mask pixels; labels and other UI metadata must not
	// invalidate mask-array layers or thumbnails.
	return hashObject({ masks: masks.filter((mask) => mask.active).map(getMaskPixelInput) })
}
